import React from 'react';
import { Link } from 'react-router-dom';
import bible from "../../assests/bible.jpg";
import god from "../../assests/god.jpg";
import jesuschrist from "../../assests/jesus.jpg";
import salivation from "../../assests/salivation.jpg";
import church from "../../assests/cf_church.jpg";

function WhatWeBelieve() {
  const beliefs = [
    {
      img: bible,
      title: "Bible",
      paragraphs: [
        "The sixty-six canonical books of the Old and the New Testament are inspired by the infallible and authoritative Word of God.",
      ],
    },
    {
      img: god,
      title: "God",
      paragraphs: [
        "There is one God, eternally existing in three persons: God the Father, God the Son, and God the Holy Spirit.",
      ],
    },
    {
      img: jesuschrist,
      title: "Jesus Christ",
      paragraphs: [
        "We believe in the deity of our Lord Jesus Christ, in His virgin birth, in His sinless life, in His miracles, in His vicarious and atoning death, in His bodily resurrection, in His ascension to the right hand of the Father, in the rapture of the Church at Christ's coming, and His glorious thousand-year rule on earth.",
      ],
    },
    {
      img: salivation,
      title: "Salvation",
      paragraphs: [
        "The only way of being cleansed from sin is through repentance and faith in the precious blood of Jesus Christ. Regeneration by the Holy Spirit is absolutely essential for personal salvation, in the identification of the believer with Christ's death and resurrection by immersion baptism.",
        "The redemptive work of Christ on the cross provides healing to the human body in answer to believing prayer. The baptism in the Holy Spirit, according to Acts 2:4, is given to believers who ask for it, in the sanctifying power of the Holy Spirit by whose indwelling the Christian is enabled to live a Holy life.",
      ],
    },
    {
      img: church,
      title: "Church",
      paragraphs: [
        "The Church is the fellowship of all who have become children of God through faith in Christ and have been knit together by the Holy Spirit into one body of which the Lord Jesus is the head.",
        "The Church is given the mandate by the Risen Lord Jesus and is under the obligation to demonstrate and proclaim the wholeness of the Gospel and its implications to every people.",
      ],
    },
  ];

  return (
    <div style={{ fontFamily: "'Georgia','Times New Roman',serif", color: "#222", backgroundColor: "#fff" }}>
      <div style={{ maxWidth: "860px", margin: "0 auto", padding: "0 1.5rem 3.5rem" }}>
        {/* ── Back link ── */}
        <Link to="/" style={{ fontSize: "13px", color: "#c47a1e", margin: "1.5rem 0 0", display: "inline-block", textDecoration: "none", userSelect: "none" }}>
          ← Back to Home
        </Link>

        {/* ── "What We Believe" heading ── */}
        <h1 style={{ fontFamily: "'Dancing Script','Brush Script MT',cursive", fontSize: "2.4rem", color: "#c47a1e", margin: "1.2rem 0 0.6rem", fontWeight: 700 }}>
          What We Believe
        </h1>

        {/* ── Intro text ── */}
        <p style={{ fontSize: "13.5px", lineHeight: "1.75", color: "#333", marginBottom: "0.3rem" }}>
          Christ For India exists to fulfill Christ's Great Commission to India.
        </p>
        <p style={{ fontSize: "13.5px", lineHeight: "1.75", color: "#333", marginBottom: "1.4rem" }}>
          Our motto is <strong><em>Reaching One Billion Plus Souls For Christ.</em></strong>
        </p>

        <div style={{ display: "flex", gap: "4px", marginBottom: "2.5rem" }}>
          {[...Array(9)].map((_, i) => (
            <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#c47a1e" }} />
          ))}
        </div>

        {/* ── Belief rows ── */}
        {beliefs.map((b, i) => (
          <div key={i} style={{
            display: "flex", gap: "1.8rem", alignItems: "flex-start",
            marginBottom: "2.8rem", flexWrap: "wrap",
          }}>
            <img src={b.img} alt={b.title}
              style={{ width: "260px", height: "180px", flexShrink: 0, borderRadius: "4px", objectFit: "cover" }} />
            <div style={{ flex: 1, minWidth: "220px" }}>
              <h3 style={{ fontSize: "1.15rem", fontWeight: 700, color: "#222", margin: "0 0 0.7rem" }}>
                {b.title}
              </h3>
              {b.paragraphs.map((p, j) => (
                <p key={j} style={{ fontSize: "13.5px", lineHeight: "1.75", color: "#444", marginBottom: "0.75rem" }}>
                  {p}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WhatWeBelieve;
